import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45f372f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=45f372f2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f372f2",
  null
  
)

component.options.__file = "index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/TagsView/index.vue
// module id = null
// module chunks = 